import { PopoverPosition, Position, Text } from "@blueprintjs/core";
import { ReactElement, useCallback, useState } from "react";
import omit from "lodash/omit";

import { DropdownSelectWithSearch } from "src/components/dropdown-select-with-search/dropdown-select-with-search";
import { Tag } from "src/components/tag/tag";
import { ConversationTag } from "src/store/conversations";
import { ListItemWithCheckBox } from "../../../chat/components/list-item-with-check-box/list-item-with-check-box";
import { DropdownContent } from "../../../dropdown-content/dropdown-content";
import styles from "./styles.module.scss";
import { EmptyBlock } from "src/components";
import classNames from "classnames";
import { TagsDropdownFooter } from "../../../chat/components/chat-sub-header/components/tags-dropdown/components/tags-dropdown-footer/tags-dropdown-footer";
import isEmpty from "lodash/isEmpty";
import { useConversationsTags } from "../../../chat/hooks/useConversationsTags";
import { DropdownTagItemWithParent } from "src/components/dropdown-tag-item-with-parent/dropdown-tag-item-with-parent";
import { InfiniteScroll } from "../../../../../../components/infinite-scroll/infinite-scroll";
import { MPDSelectItem } from "../../../../../../mpd-library";
import { EmptyBlockTypes } from "../../../../../../components";
import { ReactComponent as DropdownSearchNoResultsIcon } from "src/mpd-library/icon/assets/dropdownSearchNoResults.svg";
import { ReactComponent as EmptyTagsIcon } from "src/mpd-library/icon/assets/emptyTags.svg";

const classname = "tags-dropdown";

type TagsDropdownProps = {
    dropdownWithSearchClassName?: string;
    title?: string;
    notSelectedTagsSubtitle?: string;
    existingTagsForSelector: any;
    selectedTagsSubtitle: string;
    passDropdownId: boolean;
    revertChanges?: () => void;
    footer: () => ReactElement | null;
    onFooterApply: (checkedTagsMatchObject: { [key: string]: boolean }) => void;

    alreadySelectedTagsMatchObject: { [key: string]: boolean };
};

export const TagsDropdown = ({
    dropdownWithSearchClassName,
    title,
    selectedTagsSubtitle = "EXISTING",
    notSelectedTagsSubtitle = "ADD TAGS",
    passDropdownId,
    onFooterApply, // function which save selected tags to parent state
    alreadySelectedTagsMatchObject
}: TagsDropdownProps) => {
    // state
    const [tagsSearchValue, setTagsSearchValue] = useState<string>("");
    const [isOpen, setIsOpen] = useState(false);
    const [checkedTagsMatchKeys, setCheckedTagsMatchKeys] = useState<{ [key: string]: boolean }>(
        alreadySelectedTagsMatchObject
    );

    const {
        getTagsProcessing,
        selectedTagsIds,
        notSelectedTagsIds,
        tagsAllIds,
        tagsById,
        hasMore: hasMoreTags,
        getTags
    } = useConversationsTags({
        checkedTagsMatchKeys,
        searchValue: tagsSearchValue,
        showDidsbledParent: true
    });

    const onDeleteTagClick = (e, tagId) => {
        e?.stopPropagation?.();
        setCheckedTagsMatchKeys(omit(checkedTagsMatchKeys, tagId));
        onFooterApply(omit(checkedTagsMatchKeys, tagId));
    };

    const renderSelectedTagsItemsComponent = useCallback(() => {
        return selectedTagsIds.map((tagId: string) => {
            return (
                <Tag
                    label={tagsById[tagId].name}
                    className={styles[`${classname}-tag`]}
                    key={tagId}
                    onDeleteClick={(e) => onDeleteTagClick(e, tagId)}
                />
            );
        });
    }, [selectedTagsIds, tagsById]);

    const onClickTagCheckbox = (tag: ConversationTag) => {
        let valueToSet;

        if (checkedTagsMatchKeys[tag.id]) {
            valueToSet = omit({ ...checkedTagsMatchKeys }, tag.id);
            setCheckedTagsMatchKeys(valueToSet);
        } else {
            valueToSet = { ...checkedTagsMatchKeys, [tag.id]: true };
            setCheckedTagsMatchKeys(valueToSet);
            setTagsSearchValue("");
        }

        onFooterApply(valueToSet);
    };

    const onControlPopover = (value: boolean) => {
        setIsOpen(value);
        if (value) {
            const elem = document.getElementById("tagsDropdownWrapper");
            elem && elem.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (!value) {
            revertChanges();
        }
    };

    const revertChanges = () => {
        setCheckedTagsMatchKeys(alreadySelectedTagsMatchObject);
    };

    const onInputKeyDownBackSpace = () => {
        const checkedTagsIdsArray = Object.keys(checkedTagsMatchKeys);
        setCheckedTagsMatchKeys(omit(checkedTagsMatchKeys, checkedTagsIdsArray[checkedTagsIdsArray.length - 1]));
    };
    console.log("TAGS ???? ", notSelectedTagsIds);

    return (
        <DropdownSelectWithSearch
            wrapperId={passDropdownId ? "tagsDropdownWrapper" : undefined}
            modifiers={passDropdownId ? { ...{ flip: { enabled: false } } } : undefined}
            title={title}
            inputPlaceholder={"Search for tags..."}
            onChangeSearchInput={setTagsSearchValue}
            selectedItemsComponent={renderSelectedTagsItemsComponent()}
            contentWrapperClassName={classNames(
                styles[`${classname}-search-dropdown-content-wrapper`],
                "tags-dropdown-content-wrapper"
            )}
            position={Position.BOTTOM}
            onContorolPopoverFromParent={onControlPopover}
            isOpenFromParent={isOpen}
            className={dropdownWithSearchClassName}
            controlInputFromParent
            searchValueFromParent={tagsSearchValue}
            displayInputAndSelectedInOneBlock
            onInputKeyDownBackSpace={onInputKeyDownBackSpace}
            notShowLeftIcon={!isEmpty(checkedTagsMatchKeys)}
            list={
                <DropdownContent
                    content={
                        <InfiniteScroll
                            loading={getTagsProcessing}
                            onLoadMore={getTags}
                            hasMore={hasMoreTags}
                            listLength={tagsAllIds.length}
                        >
                            <>
                                {!!selectedTagsIds?.length && !tagsSearchValue && (
                                    <>
                                        <Text
                                            className={`${styles[`${classname}-tags-group-title`]}  ${styles["first"]}`}
                                        >
                                            {selectedTagsSubtitle}
                                        </Text>
                                        <div className={styles[`${classname}-items-wrapper`]}>
                                            {selectedTagsIds.map((tagId: string) => {
                                                const tag = tagsById[tagId];
                                                return (
                                                    // <ListItemWithCheckBox
                                                    //     item={tag}
                                                    //     name={tag.name}
                                                    //     id={tag.id}
                                                    //     onClickCheckbox={onClickTagCheckbox}
                                                    //     checked
                                                    //     nameComp={
                                                    //         <DropdownTagItemWithParent
                                                    //             tag={tag}
                                                    //             tagsSearchValue={tagsSearchValue}
                                                    //         />
                                                    //     }
                                                    // />
                                                    <MPDSelectItem
                                                        onCheckBoxClick={onClickTagCheckbox}
                                                        id={tag.id}
                                                        key={tag.id}
                                                        option={tag}
                                                        label={tag.name}
                                                        checked
                                                        withCheckbox
                                                        children={
                                                            <DropdownTagItemWithParent
                                                                tag={tag}
                                                                tagsSearchValue={tagsSearchValue}
                                                                hideAccentor
                                                            />
                                                        }
                                                    />
                                                );
                                            })}
                                        </div>
                                    </>
                                )}
                                {!!notSelectedTagsIds?.length &&
                                    notSelectedTagsIds?.length !== Object.keys(checkedTagsMatchKeys).length && (
                                        <>
                                            <Text
                                                className={`${styles[`${classname}-tags-group-title`]} ${
                                                    styles[
                                                        `${
                                                            !selectedTagsIds?.length || tagsSearchValue
                                                                ? "first"
                                                                : "second"
                                                        }`
                                                    ]
                                                }`}
                                            >
                                                {notSelectedTagsSubtitle}
                                            </Text>
                                            <div className={styles[`${classname}-items-wrapper`]}>
                                                {notSelectedTagsIds.map((tagId: string) => {
                                                    const tag = tagsById[tagId];
                                                    return (
                                                        // <ListItemWithCheckBox
                                                        //     name={tag.name}
                                                        //     id={tagId}
                                                        //     onClickCheckbox={onClickTagCheckbox}
                                                        //     checked={checkedTagsMatchKeys[tagId]}
                                                        //     item={tag}
                                                        //     disabled={checkedTagsMatchKeys[tagId] && !!tag.nodes.length}
                                                        //     iconName={tag.ancestors_formatted && "enterIcon"}
                                                        //     nameComp={
                                                        //         <DropdownTagItemWithParent
                                                        //             tag={tag}
                                                        //             tagsSearchValue={tagsSearchValue}
                                                        //             hideAccentor
                                                        //         />
                                                        //     }
                                                        // />
                                                        <MPDSelectItem
                                                            option={tag}
                                                            onCheckBoxClick={onClickTagCheckbox}
                                                            withCheckbox
                                                            key={tagId}
                                                            id={tagId}
                                                            label={tag.name}
                                                            disabled={checkedTagsMatchKeys[tagId] && !!tag.nodes.length}
                                                            leftIcon={tag.ancestors_formatted && "enterIcon"}
                                                            children={
                                                                <DropdownTagItemWithParent
                                                                    tag={tag}
                                                                    tagsSearchValue={tagsSearchValue}
                                                                    option={tag}
                                                                    key={tag.id}
                                                                />
                                                            }
                                                        />
                                                    );
                                                })}
                                            </div>
                                        </>
                                    )}
                                {!getTagsProcessing && !tagsAllIds?.length && !tagsSearchValue && (
                                    <EmptyBlock
                                        title={"No tags available"}
                                        subtitle={"You can add new tags in Conversations Settings."}
                                        IconComponent={EmptyTagsIcon}
                                        type={EmptyBlockTypes.dropdown}
                                    />
                                )}
                                {!getTagsProcessing && !notSelectedTagsIds?.length && !!tagsSearchValue && (
                                    <EmptyBlock
                                        title={`No results for ‘${tagsSearchValue}’`}
                                        // subtitle={"Please try another query"}
                                        IconComponent={DropdownSearchNoResultsIcon}
                                        type={EmptyBlockTypes.dropdown}
                                    />
                                )}
                            </>
                        </InfiniteScroll>
                    }
                    // footer={
                    //     <TagsDropdownFooter
                    //         checkedTags={checkedTagsMatchKeys}
                    //         setCheckedTags={setCheckedTagsMatchKeys}
                    //         applyTagsChanges={() => {
                    //             onFooterApply(checkedTagsMatchKeys);
                    //             setIsOpen(false);
                    //         }}
                    //     />
                    // }
                />
            }
        />
    );
};
